/* template */
<template><div :class="(bottomBarClass)" :style="[(customStyle)] | transRpxStyle" class="list-content"><div class="fee-info-warn" v-if="(priceDetailCardTip)"><mpx-image src="https://dpubstatic.udache.com/static/dpubimg/cxFbrFo8rY23sNI4pJzRg.png" class="warn-icon"/><span class="warn-copywritting">{{priceDetailCardTip}}</span></div><div v-for="(item, index) in (formatFeeInfo)" class="fee-container" v-if="(formatFeeInfo && Object.keys(formatFeeInfo).length)"><div class="fee-info-title" v-if="(item.title)"><mpx-view @tap="goPage(item)" class="fee-info-item"><div class="fee-info-item-title">{{ item.title }}</div><div :style='[("color:"+(item.color))] | transRpxStyle' class="rich-text-bold">¥{{ item.price / 100 }}<es-icon name="angle-right" color="#999999" size="16" v-if="(item.show_arrow)"/></div></mpx-view><div class="fee-info-item-tip-left">{{ item.left_tip }}</div><div class="fee-info-item"><div class="fee-info-item-tip-left">{{ item.create_time }}</div><div class="fee-info-item-tip-right">{{ item.right_tip }}</div></div></div><div :class="(item?.fee_item?.length > 1 && 'muti-row')" class="content-bg" v-if="(item.fee_item && item.fee_item.length > 0)"><template v-for="(fee, index) in (item.fee_item)"><div class="fee-content-item"><div :style='[("color:"+(fee.color)+";fontWeight:"+(fee.bold ? "bold" :"")+";fontSize:"+(fee.pixel))] | transRpxStyle' class="fee-content-item-left"><mpx-image :src="(fee.icon)" class="icon" v-if="(fee.icon)"/><div>{{ fee.name }}</div></div><div :class="(fee.value && fee.name && fee.bold && !fee.notLine ? 'fee-info line' : 'fee-info')"></div><div :style='[("color:"+(fee.valueColor))] | transRpxStyle' class="fee-content-item-right"><div class="appointment-tag" v-if="(fee.type && fee.type === '学生票')">约</div>{{ fee.value }}</div></div></template></div></div><div class="student-tip" v-if="(studentLength > 0)">学生票面金额为预估价，最终以实际占座成功为准。</div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m71c8fd7c"}'>
  @import '~@/mixins/stylus/color.styl'

  .main, .list-content
    background-color #ffffff
    border-radius 8px
    display flex
    flex-direction column
    &-bottom-margin
      margin 0 12px 100px 12px
    &-no-bottom
      margin 0 12px 33px 12px
    .fee-container:last-child
      margin-bottom 30px
    .student-tip
      font-size 11px
      color #999999
      text-align center
  .fee-info-warn
    margin-bottom 16px
    margin-left 4px
    display flex
    align-items center
  .warn-icon
    height 10px
    width 10px
    flex none
    margin-right 2px
  .warn-copywritting
    font-size 12px
    line-height 12px
    letter-spacing 0px
    color #666666
  .fee-info-title
    margin 5px 12px 12px
  .fee-info
    margin 0px 10px
    width 100%
    margin-top 10px
    &.line
      border-top 1px dashed #cccccc
  .fee-content-item
    display flex
    align-items flex-start
    padding-top 16px
    &-left
      color $train-color-999
      font-size 14px
      white-space nowrap
      display flex
      align-items center
      .icon
        width 16px
        height 16px
        margin-right 4px
    &-right
      color #666
      font-family PingFangSC-Regular
      font-size 14px
      line-height 20px
      white-space nowrap
      display flex
      .appointment-tag
        margin-right 4px
    .red-color
      color #FF4343
  .content-bg
    background #F6F9FD
    border-radius 10px
    padding 0px 12px 16px
    margin-bottom 8px
    &.muti-row
      background #eaf3ff
	    box-sizing border-box
	    border 0.5px solid #8fc8e9
    &:not(:last-child)
      margin-bottom 8px
  .fee-info-item-title
    color $train-color-333
    font-size 15px
    font-weight 500
    font-family PingFangSC
    // white-space nowrap
  .divider
    height 1px
    border-top 1px solid rgba(0, 0, 0, 0.04)
    text-align center
  .fee-info-item
    display flex
    justify-content space-between
    align-items flex-start
    &-tip-left
      color $train-color-999
      font-size 12px
    &-tip-right
      display flex
      color $train-color-theme-blue
      font-size 12px
      line-height 12px
  .rich-text-bold
    font-family PingFangSC-Semibold
    font-size 18px
    letter-spacing 0
    text-align right
    display flex
    align-items center
    color $train-color-theme-blue
    font-weight normal
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m71c8fd7c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex71c8fd7c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex71c8fd7c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m71c8fd7c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index71c8fd7c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
